export default __webpack_public_path__ + "static/media/Imagethirteen.2e8d2779.jpeg";